<template>
	<BaseCmsRotator :fetch="{code: 'hero', response_fields: ['id', 'title', 'title2', 'image_thumbs', 'image_2_thumbs', 'element_cta', 'url_without_domain', 'link', 'content']}" v-slot="{items}">
		<div class="hero" v-if="items?.length">
			<BaseUiSwiper :options="{
				slidesPerView: 1,
				slidesPerGroup: 1,
				speed: 500,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				loop: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: true
				},
				pagination: {
					enabled: true,
					clickable: true,
				},
			}">
				<BaseUiSwiperSlide v-for="(item, index) in items" :key="item.id">
					<div class="overlay">
						<div class="cnt">
							<div class="headline" v-if="item.title2">{{ item.title2 }}</div>
							<div class="title" v-if="item.title">{{ item.title }}</div>
							<div class="content" v-if="item.content" v-html="item.content"/>
							<div class="cta" v-if="item.link">
								<NuxtLink class="btn btn-white" :to="item.link">{{item.element_cta}}</NuxtLink>
							</div>
						</div>
					</div>
					<BaseUiImage :data="item.image_thumbs?.['width1920-height740-crop1']" :picture="[{maxWidth: '980px', src: item.image_2_thumbs?.['width980-height1140'].thumb, default: '/images/no-image-980.jpg'}]" :loading="index === 0 ? 'eager' : 'lazy'" />
				</BaseUiSwiperSlide>
			</BaseUiSwiper>
		</div>
	</BaseCmsRotator>
</template>

<script setup>

</script>

<style scoped lang="less">
	:deep(img){width: 100%; display: block;}
	:deep(.swiper-navigation){
		.swiper-button{
			background: none; box-shadow: none;
			&:after{.icon-arrow-right(); font-size: 35px; color: #fff;}
		}
		.swiper-button-prev{left: 20px;}
		.swiper-button-next{right: 20px;}
		@media (max-width: @m){display: none!important;}
	}
	:deep(.swiper-slide){
		position: relative;
	}
	.overlay{position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 1; display: flex; align-items: center; justify-content: center;}
	.cnt{
		text-align: center; color: #fff; font-size: 20px; max-width: 715px;
		@media (max-width: @m){padding: 0 0; font-size: 14px; max-width: 312px;}
	}
	.title{
		font-size: 64px; line-height: 1.1; font-weight: bold; padding: 8px 0;
		@media (max-width: @l){font-size: 48px;}
		@media (max-width: @t){font-size: 32px;}
		@media (max-width: @m){font-size: 30px;}	
	}
	.headline{
		text-transform: uppercase; font-size: 16px; font-weight: bold;
		@media (max-width: @m){font-size: 12px;}	
	}
	.cta{
		padding-top: 15px;
		@media (max-width: @m){padding-top: 10px;}	
	}
	:deep(.btn){
		border: 0; padding: 18px 30px;
		@media (max-width: @m){width: auto; padding: 15px 26px 13px;}
	}
	:deep(.swiper-pagination){
		position: absolute; bottom: 40px; left: 0; right: 0; z-index: 10; display: flex; align-items: center; justify-content: center; gap: 15px; cursor: pointer;
		.swiper-pagination-bullet{width: 60px; height: 6px; background: #fff; display: block; box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3); border-radius: 1px;}
		.swiper-pagination-bullet-active{background: var(--blue2);}
		@media (max-width: @m){
			bottom: 20px; padding: 0 16px;
			.swiper-pagination-bullet{width: 40px; height: 5px;}
		}
	}
</style>